import React from "react";
import DEFAULT_CONFIG from '../../../configs/default.json'
import { Grid, IconButton, Typography } from "@mui/material";
import FxCard from "../../Container/FxCard";
import { ReactComponent as DrawerClose } from '../../../assets/svg/signup/drawer-close.svg';
import { FxCopyToClipboard } from "../../Data/FxCopyToClipboard";
import { ReactComponent as DividerIcon } from "../../../assets/svg/divider-icon.svg";
/**
 * Author : Athul PP
 * Component Name : "ContactUsDrawer"
 * Component Description : This component is responsible for contact us signup.
 * 
 */
export const ContactUsDrawer: React.FC<any> = React.memo((props) => {
  const cType = props?.cType;

  /*
Construct contact_data array based on customer type (cType):
- If cType is 'BUSINESS', include Business Banking contact.
- If cType is not 'BUSINESS', include Consumer Banking contact.
- Always include the general contact email.
*/

    const contact_data = [
      ...(cType === 'BUSINESS' ? [{
        title: "Business Banking: ",
        contact: DEFAULT_CONFIG['CONTACT_INFORMATION']['BUSINESS_BANKING_CONTACT']
      }] : []),
    
      ...(cType !== 'BUSINESS' ? [{
        title: "Consumer Banking: ",
        contact: DEFAULT_CONFIG['CONTACT_INFORMATION']['CONSUMER_BANKING_CONTACT']
      }] : []),
    
      {
        title: "Email: ",
        contact: DEFAULT_CONFIG['CONTACT_INFORMATION']['CONTACT_US_EMAIL']
      }
    ];
    return (
       <Grid>
        <FxCard className="fx-replace-debit-card-modal">
        <Grid container className="fx-contact-us-drawer-container">
            <Grid container className="fx-contact-us-drawer-header">
            <Typography
                id="fx-contact-us-modal-modal-title"
                align="center"
                className="fx-replace-debit-card-modal-title"
              >
                Contact us
              </Typography>
              <Grid item>
                        <IconButton onClick={props?.onClose}>
                          <DrawerClose />
                        </IconButton>
                      </Grid>
            </Grid>
            <Grid item xs={12} className="fx-modal-form flex column">
            <Typography
              id="title-delete-modal"
              variant="h3"
              textAlign={"center"}
              className="fx-contact-us-main-text"
            >
              For Priority Passport Customer Support, please contact us at:
            </Typography>
          </Grid>
          <Grid
            container
            className="fx-modal-form flex column fx-contact-us-form-body"
          >
            {contact_data.map((item: any, index: any) => {
              return (
                <>
                <Grid
                  id={"fx-contact-us-items-" + index}
                  className={"fx-contact-us-form-body-items"}
                >
                  <Grid>
                    <Typography>{item.title}</Typography>
                  </Grid>
                  <Grid>
                    <Typography className="fx-contact-us-form-body-numbers">
                      {item.contact}
                    </Typography>
                  </Grid>
                  <Grid>
                    <FxCopyToClipboard
                      hideSnackbar={true}
                      id="passport-customer-token-copy-to-clipboard"
                      value={item.contact}
                      message="Copied to clipboard"
                    />
                  </Grid>
                
                </Grid>
                  <Grid><DividerIcon /></Grid>
                  </>
              );
            })}
          </Grid>
          <Grid className="fx-contact-us-note-text ">
            <Typography id="title-contact-us-modal-moddsal">
              Hours of Operation: 
            </Typography>
            <Typography className="fx-contact-us-note-text-colored"> &nbsp;
               {DEFAULT_CONFIG['CONTACT_INFORMATION']['OPERATION_HOURS']}
              </Typography> 
          </Grid>
            </Grid>
        </FxCard>
       </Grid>
    );
});